import { render, staticRenderFns } from "./addReward.vue?vue&type=template&id=ec6842e6&scoped=true&"
import script from "./addReward.vue?vue&type=script&lang=js&"
export * from "./addReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6842e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec6842e6')) {
      api.createRecord('ec6842e6', component.options)
    } else {
      api.reload('ec6842e6', component.options)
    }
    module.hot.accept("./addReward.vue?vue&type=template&id=ec6842e6&scoped=true&", function () {
      api.rerender('ec6842e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/rewardController/component/addReward.vue"
export default component.exports